export default {
  name: {
    id: 'rm_metal_gold_name',
    defaultMessage: 'Gold',
  },
  smartphoneLabel: {
    id: 'rm_metal_gold_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_gold_what_it_does',
    defaultMessage:
      "Referred to as \"the gold standard\", because it's a metal that never corrodes, gold also resists current. This makes it perfect to use in the super tiny bonding wires that connect chips to circuit boards. Additonally, gold is used in smartphone' cameras to keep the sensor's electrical connection awake and alive.",
  },
  extractionText1: {
    id: 'rm_metal_gold_extraction_p1',
    defaultMessage:
      'Gold is one of the most widely mined materials on Earth and it is extracted in five continents. Multinational corporations tend to operate massive open-pit mines with heavy machinery, while an estimated 15 to 20 million artisanal miners digg by hand with basic tools, together producing 20% of global supply. These two methods frequently overlap, sharing the same ground under very different conditions.',
  },
  extractionText2: {
    id: 'rm_metal_gold_extraction_p2',
    defaultMessage:
      'Large mines use cyanide to dissolve gold from crushed ore; artisanal miners more commonly use mercury, burning it off to recover the metal.',
  },
  quickFactText: {
    id: 'rm_metal_gold_quick_fact',
    defaultMessage:
      '2,200 lbs of soil must be moved and processed to make a single 0.35 oz gold ring. Scaled up, that is millions of tons of rock displaced every year, which subsequently devastates rivers, land, and communities worldwide.',
  },
  envSummaryText: {
    id: 'rm_metal_gold_env_summary',
    defaultMessage:
      "Moving mountains is not a metaphor with gold. Its typical deposits contain just 0.32 ounces per ton of rock, meaning 110,000 tons must be moved, crushed, and discarded just to extract 2,200 lbs: this is 100,000 times more waste than iron. Industrial mines descend up to 2.5 miles underground. Artisanal miners use mercury to bind gold particles before burning it off, creating the world's largest source of intentional mercury pollution.",
  },
  envWaterText: {
    id: 'rm_metal_gold_env_water_text',
    defaultMessage:
      'Rock crushing triggers a chemical reaction, producing highly acidic water loaded with arsenic, cadmium, mercury, and lead. This seeps into rivers and groundwater for thousands of years after a mine closes. Fresh water consumption is equally staggering: producing just 2.6 oz of gold, enough for a single watch, uses an average of 700 gallons. Artisanal mining alone emits over 2,200 tons of mercury per year, representing 37% of all human-caused mercury emissions globally, making it the largest source on Earth (ahead of coal-fired power plants). Mercury levels in Amazonian rivers are now 34 times above safe limits.',
  },
  envSoilText: {
    id: 'rm_metal_gold_env_soil_text',
    defaultMessage:
      'The mercury from gold does not degrade: it accumulates indefinitely in soils, rivers, and food chains. Forest canopies near mines intercept atmospheric mercury, amplifying contamination of surrounding ecosystems. Mining strips soil of nutrients and leaves behind high concentrations of heavy metals. Studies show forests cleared for gold mining have some of the lowest recovery rates ever recorded, leaving land effectively dead for decades.',
  },
  envBiodiversityText: {
    id: 'rm_metal_gold_env_biodiversity_text',
    defaultMessage:
      'Gold is the mineral most frequently extracted inside forests: nearly half of all active gold mines sit in areas of exceptional ecological value. In the Peruvian Amazon alone, artisanal mining destroyed over 386 square miles of rainforest between 1984 and 2017. Destruction spreads far beyond the mine too, with infrastructure fragmenting habitats up to 43.5 miles from a concession, opening untouched areas to poaching and illegal logging.',
  },
  envClimateText: {
    id: 'rm_metal_gold_env_climate_text',
    defaultMessage:
      "Every pound of gold produced releases the equivalent of 12,500 lbs of CO2. Total global gold production in 2019 released 45 million tons of greenhouse gases. For context, zinc requires a similar amount of energy globally but delivers 4,000 times more material for that same energy cost. Gold is, by every measure, an extraordinarily inefficient use of our planet's resources.",
  },
  humanSummaryText: {
    id: 'rm_metal_gold_human_summary',
    defaultMessage:
      "Artisanal gold mining employs 15 to 20 million people worldwide. Operating with little to no safety protection these miners are directly exposed to mercury, causing irreversible neurological damage. Gold is also one of four metals, alongside tin, tantalum, and tungsten, formally classified as 'conflict minerals' by the European Union, meaning their extraction has been documented as funding armed groups, forced child labour, and government-backed militias across West Africa, the DRC, and Latin America.",
  },
  humanDisplacementText: {
    id: 'rm_metal_gold_human_displacement_text',
    defaultMessage:
      'Large-scale mining requires land, often already inhabited. When the Grasberg mine (one of the world’s largest gold mines) was developed in Papua, Indonesia, 15,000 residents were forcibly displaced during its development. Around 4,000 Indigenous Amungme people received no compensation and were relocated to malaria-endemic areas, where several hundred reportedly died after relocation. One mine. One decision. And hundreds of lives lost, not from mining, but from being pushed aside to make room for it.',
  },
  humanHealthText: {
    id: 'rm_metal_gold_human_health_text',
    defaultMessage:
      'When mercury is burned to extract gold, miners inhale fumes directly, often in confined spaces and without protection. No safe level of mercury exposure has been established. An estimated 100 million people are directly or indirectly exposed to mercury through artisanal gold mining worldwide. In pregnant women, methylmercury can cross the placenta and permanently damage fetal neurological development. Silica dust, inhaled during drilling, causes irreversible lung scarring that worsens over a lifetime.',
  },
  humanChildLabourText: {
    id: 'rm_metal_gold_human_child_labour_text',
    defaultMessage:
      'Artisanal mining accounts for around 90% of the world’s gold miners, yet produces only 20% of global supply. Among its 10 to 15 million workers across 81 countries, 4 to 5 million are women and children, working in hand-dug tunnels that can collapse at any moment while handling toxic chemicals without safety equipment or legal protection.',
  },
  humanGenderText: {
    id: 'rm_metal_gold_human_gender_text',
    defaultMessage:
      'The towns that grow around artisanal gold mining sites carry their own crisis. In Peru, women and girls as young as 12 are trafficked from poorer regions to mining towns in Madre de Dios and Puno, lured by fake job offers. The illegal mining town of Delta 1 alone is estimated to have 2,000 sex workers, 60% of them minors. In La Rinconada, over 4,500 girls from Peru and Bolivia are estimated to be trafficked for sex work in areas largely frequented by miners.',
  },
  humanLegalText: {
    id: 'rm_metal_gold_human_legal_text',
    defaultMessage:
      'Many artisanal miners operate outside formal regulatory frameworks, with no labour rights, social protection or legal recourse. Accidents are frequent but are therefore rarely recorded. Miners themselves report having no alternative to mercury use, despite knowing its dangers. For many, gold mining is not a choice but the only option available. Around 100 million people depend on artisanal gold mining for their livelihoods. Most have no union to provide meaningful protection against these risks.',
  },
  geoSummaryText: {
    id: 'rm_metal_gold_geo_summary',
    defaultMessage:
      "Gold is one of four metals formally classified as 'conflict minerals' by the EU, reflecting decades of armed groups using gold revenues to fund wars. Beyond conflict zones, gold has already been used as a geopolitical weapon: several producing countries including Indonesia and the Philippines have banned gold exports entirely, and G7 nations banned Russian gold imports following the 2022 invasion of Ukraine.",
  },
  geoDugText: {
    id: 'rm_metal_gold_geo_dug_text',
    defaultMessage:
      'Gold production is more geographically dispersed than that of most critical metals. China leads with 11.5% of global mine production, but no single country dominates the market. The five largest producers, China, Russia, Australia, Canada and the United States, together account for around 46% of global supply.',
  },
  geoProcessedText: {
    id: 'rm_metal_gold_geo_processed_text',
    defaultMessage:
      "Switzerland refines between 50 and 70% of the world's newly mined gold, making it the single largest gold refining hub on the planet. This is despite producing almost none itself. In fact, four of the seven largest gold refineries in the world are Swiss.",
  },
  geoLeverageText: {
    id: 'rm_metal_gold_geo_leverage_text',
    defaultMessage:
      'Export restrictions on gold are already in place in several producing countries: Indonesia and the Philippines have banned gold exports entirely, while the DRC, Zimbabwe, and Guinea apply export taxes. In 2022, G7 nations banned imports of Russian gold following the invasion of Ukraine, the clearest example to date of gold being used as a geopolitical instrument.',
  },
  supplySummaryText: {
    id: 'rm_metal_gold_supply_summary',
    defaultMessage:
      'Gold does not corrode and can theoretically be recycled indefinitely. Yet mining continues, while systems for recovering and reusing gold from discarded devices remain deeply inadequate. Known reserves could support nearly two decades of production at current rates, but this simple ratio is not a depletion forecast: reserves change with exploration, prices and technology.',
  },
  supplyReservesText: {
    id: 'rm_metal_gold_supply_reserves_text',
    defaultMessage:
      'Global gold reserves are estimated at 64,000 tonnes, compared with annual mine production of around 3,300 tonnes. This corresponds to a simple reserve-to-production ratio of roughly 19 years. It should not be interpreted as a forecast of when gold will run out, because reserves can change over time. Experts consider gold to face one of the highest depletion risks among critical metals, and rising demand could increase pressure on supply.',
  },
  supplyDemandText: {
    id: 'rm_metal_gold_supply_demand_text',
    defaultMessage:
      'Gold currently accounts for 2% of metal demand from the digital sector. By 2050, this share is projected to reach 10%, excluding demand from other high-demand sectors such as jewellery.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_gold_recycling_summary',
    defaultMessage:
      'Gold recycling exists at industrial scale, but remains a partial system, with recovery rates of 10 to 30%. The majority comes from jewellery and industrial scrap; recovery from electronics remains limited. A key and growing barrier: gold content in circuit boards is declining over time, reducing the economic incentive to recycle.',
  },
  recyclingInputText: {
    id: 'rm_metal_gold_recycling_input_text',
    defaultMessage:
      'In 2024, approximately 28% of global gold supply came from recycled sources. At least 90% of recycled gold came from jewellery, while technology and other industrial sources accounted for the remainder. This share fluctuates with gold prices and economic conditions. Gold recovered specifically from discarded electronics represents only a small fraction of recycled gold.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_gold_recycling_outlook_text',
    defaultMessage:
      "Not at current rates. Every year, tens of billions of dollars' worth of gold disappears into landfill inside discarded electronics, unrecovered and unrecyclable once lost. As devices use less gold per unit, the economic incentive to recover it weakens even as the volume of discarded electronics grows.",
  },
  mine0Region: {
    id: 'rm_metal_gold_mine0_region',
    defaultMessage: 'Carletonville',
  },
  mine1Region: {
    id: 'rm_metal_gold_mine1_region',
    defaultMessage: 'Tembagapura',
  },
  mine2Region: {
    id: 'rm_metal_gold_mine2_region',
    defaultMessage: 'Carlin',
  },
  mine3Region: {
    id: 'rm_metal_gold_mine3_region',
    defaultMessage: 'Crescent Valley',
  },
  mine4Region: {
    id: 'rm_metal_gold_mine4_region',
    defaultMessage: 'Bodaibo',
  },
  mine5Region: {
    id: 'rm_metal_gold_mine5_region',
    defaultMessage: 'Boddington',
  },
} as const
